import { render } from "./CreateOrganizationModal.vue?vue&type=template&id=dd3ba004"
import script from "./CreateOrganizationModal.vue?vue&type=script&lang=js"
export * from "./CreateOrganizationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__